/**
 * <s-reveal-group><div data-reveal style="--reveal-delay: 150ms">…</div></s-reveal-group>
 * Sets data-revealed once the group first scrolls into view; CSS in config/styles.css fades
 * each [data-reveal] child up 15px with its own delay. Undefined (no JS) = fully visible.
 */
class SRevealGroup extends HTMLElement {
  connectedCallback() {
    if (this.observer || this.hasAttribute('data-revealed')) return;
    if (!('IntersectionObserver' in window)) {
      this.setAttribute('data-revealed', '');
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.setAttribute('data-revealed', '');
        this.observer?.disconnect();
      },
      { threshold: 0.25 },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = undefined;
  }
}

if (!customElements.get('s-reveal-group')) customElements.define('s-reveal-group', SRevealGroup);
